













import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ApexOptions } from 'apexcharts';

import Chart from '@/components/Chart/Chart.vue';

import DateUtils from '@/utils/DateUtils';

function formatChartDate(date: string) {
  const formatedDate = DateUtils.formatISODate(date);

  const currentDay = new Date().getUTCDate();
  const currentMonth = new Date().getUTCMonth() + 1;
  const currentYear = new Date().getFullYear();

  const [month, day, year] = formatedDate.split('/');

  if (
    parseInt(month) === currentMonth &&
    parseInt(day) === currentDay &&
    parseInt(year) === currentYear
  )
    return 'Today';

  return `${month}/${day}`;
}

function generateSeriesMock() {
  return Array.from(Array(5).keys()).map(() => 0);
}

function generateCategoriesMock() {
  return Array.from(Array(5).keys())
    .map(pos => {
      const currentDate = new Date();

      const timestampDate = currentDate.setDate(currentDate.getDate() - pos);
      const isoStringDate = new Date(timestampDate).toISOString();

      return formatChartDate(isoStringDate);
    })
    .reverse();
}

interface IChartValue {
  x: string;
  y: string;
}

interface ICampaignStatistics {
  entries: IChartValue[];
}

@Component({
  components: {
    Chart
  }
})
export default class CampaignStatisticsChart extends Vue {
  @Prop({
    default: () => ({
      entries: []
    })
  })
  statistics?: ICampaignStatistics;
  @Prop({ default: false }) isDetail?: boolean;
  @Prop({ default: 'Members Reached per Day' }) title?: boolean;

  chartOptions: ApexOptions = {
    chart: {
      toolbar: {
        show: false
      }
    },
    xaxis: {
      categories: generateCategoriesMock()
    },
    colors: ['#3E24D6']
  };
  chartSeries: ApexAxisChartSeries = [
    {
      name: 'Members',
      data: generateSeriesMock()
    }
  ];

  getChartCategories() {
    if (!this.statistics) return generateCategoriesMock();

    return this.statistics.entries.map(({ x: campaignDate }) =>
      formatChartDate(campaignDate)
    );
  }

  getChartSeries() {
    if (!this.statistics) return generateSeriesMock();

    const series = this.statistics.entries.map(({ y: redeems }) =>
      Number(redeems)
    );

    return series;
  }

  @Watch('statistics')
  updateChart() {
    this.chartOptions = {
      ...this.chartOptions,
      ...{
        xaxis: {
          categories: this.getChartCategories()
        }
      }
    };

    this.chartSeries = [
      {
        name: 'Members',
        data: this.getChartSeries()
      }
    ];
  }
}
